import { FC, ReactNode } from 'react';
import { Button as AntdButton, ButtonProps as AntdButtonProps } from 'antd';
import { SizeType } from 'antd/lib/config-provider/SizeContext';

export interface ButtonProps extends Omit<AntdButtonProps, 'onClick'> {
  className?: string;
  children?: ReactNode;
  size?: SizeType;
  disabled?: boolean;
  key?: string | number;
  onClick: () => void;
}

export const Button:FC<ButtonProps> = (props) => {
  const {
    onClick, ...rest
  } = props;
  const handleClick = () => {
    onClick();
  };
  return (
    <AntdButton onClick={handleClick} {...rest} />
  );
};
